import React, { useEffect, useState } from "react";
import { useHistory,useNavigate,useLocation } from "react-router";
import $ from "jquery";
import axios from "axios";
import ReqService from './../../request/service';
import Waiter from './../../assets/gif/blueCircle.gif';
import CopySound from './../../assets/sound/beep07a.wav';
import { createGlobalStyle } from 'styled-components';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
import {stringToHex} from "./../forms/validator";
const GlobalStyles = createGlobalStyle`
.table {
		border:0px dotted #c0c0c0;
		
}
table.table th span { font-size:12px; color:#909090; font-weight:400;}
table.table td  { font-size:13px; color:#202020; font-weight:400;}
	.dataTables_filter input[type=search]
{
	border-radius:50rem!important;
	padding-left:1rem;
	padding-right:1rem;
	padding-top:0.2rem;
	padding-bottom:0.2rem;
	
}
div.dataTables_wrapper div.dataTables_length select {
   border-radius:50rem!important;
   padding-left:1rem;
	padding-right:1rem;
	padding-top:0.2rem;
	padding-bottom:0.2rem;
   width:120px;
}
div.dataTables_wrapper div.dataTables_length label{
	color:#404040;
	font-weight: 300;
    font-size: 0.875rem;
}
div.dataTables_wrapper div.dataTables_filter label {
    color:#404040;
	font-weight: 300;
    font-size: 0.875rem;
}
table.dataTable.table-striped>tbody>tr.odd>* {
    box-shadow: inset 0 0 0 9999px rgb(200 250 150 / 5%)!important;
}
.page-link {
	border:0px!important;
	font-size:12px;
}
.active>.page-link, .page-link.active {
    z-index: 3;
    color: #fff;
    background-color: #11b5ff;
    border-color: #11b5ff;
	box-shadow:1px 1px #999;
	border-radius:50rem;
}
.dataTables_info{
	font-size:12px;
	color:#495057;
}
.imgInCol { position:relative;
	min-width:120px!important;
	
}
.imgInCol img {
	display:inline-block;
	position:relative;
	height:28px;
	width:28px;
	border:2px solid #4567da;
	border-radius:50%;
}
`;

const JComponent = (props) => { 
	const navigate=useNavigate();
	const location = useLocation();
	const [disabled,setDisabled]=useState(false);
	const [cols,setCols]=useState([]);
	const [rows,setRows]=useState([]);
	const [rowsClone,setRowsClone]=useState([]);
	const [fetchOnReq,setFecthOnReq]=useState(false);
	const [assetsCategoryList,setAssetsCategoryList]=useState([]);
	const [implAgencyList,setImplAgencyList]=useState([]);
  	const [fundingAgencyList,setFundingAgencyList]=useState([]);
  	const [userAgencyList,setUserAgencyList]=useState([]);
	const [showImageBox,setShowImageBox]=useState(false);
	const [showQRBox,setShowQRBox]=useState(false);
	const [selectedImages,setSelectedImages]=useState([]);
	const [selectedQRImage,setSelectedQRImage]=useState("");
	const [pageTitle,setPageTitle]=useState("Assets & Projects List");
	const [isDelayPage,setIsDelayPage]=useState(false);
	const [getPDFToken,setPDFToken]=useState("{email:''}");
	let _TX=1;
	useEffect(()=>{ 
		if(_TX==1){ _TX++;
		loadAssetCategoryList();
		loadImplAgencyList();
		loadUserAgencyList();
		let _rows=[];
		setRows([]);
		
		setCols([
			"Update.Date",
			"Update.Info",
			"Asset.Type",
			"Asset.Name",
			"Implementing.Agency",
			"Funding.Agency",
			"User.Agency",
			"Panchayat",
			"Block",
			"Beneficiary",
			"Agr.Cost",
			"Agr.Date",
			"Est.Cost",
			"EstWorkStartDate",
			"EstWorkCompleteByDays",
			"WorkStartDate",
			"WorkFinishDate",
			"WorkStatus",
			"WorkProgress",
			"Lat",
			"Lng",
			"ContractorName"
			
		]);
			let requestDocumentFor=location.state?.requestFor;
			let _url="";
			
			let _d={
					token:localStorage.getItem("_xoxex"),
					email:localStorage.getItem("_xoxem"),
				};
			let idata=stringToHex(JSON.stringify(_d));	
			setPDFToken(idata);
			_url="/api/document/get-documents-workupdated.php";
			setFecthOnReq(true);	
			var config = {
				method: 'post',
				url: API_CORE_SERVER+_url,
				headers: { 
					'Content-Type': 'application/x-www-form-urlencoded',
					//'Content-Type': 'application/json', 
				},
				data:"i="+idata
			  };
			  axios(config).then(response=>{
				if(response.status===200 && response.data){
					let data=response.data;
					if(data.status===1 && data.data && data.data.length>0){
						let records=data.data;
						for(let i=0;i<records.length;i++){
							let slno=records[i].slno;
							let assetId=records[i].assetId;
							const idate=records[i].idate;
							try{
									let rec=JSON.parse(records[i].data);
									 _rows.push({ 
										slno:slno,
										assetId:assetId,
										assetType:rec.assetInfo.assetType,
										assetName:rec.assetInfo.assetName,
										implementAgency:rec.assetInfo.implementAgency,
										fundingAgency:rec.assetInfo.fundingAgency,
										userAgency:rec.assetInfo.userAgency,
										assetDescription:rec.assetInfo.assetDescription,
										panchayat:rec.assetInfo.panchayat,
										block:rec.assetInfo.block,
										beneficiary:rec.assetInfo.beneficiary,
										agrCost:rec.assetDetail.agrCost,
										agrDate:rec.assetDetail.agrDate,
										estCost:rec.assetDetail.estCost,
										estWorkStartDate:rec.assetDetail.estWorkStartDate,
										estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
										workStartDate:rec.assetDetail.workStartDate,
										workFinishDate:rec.assetDetail.workFinishDate,
										workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
										workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
										lat:rec.assetDetail.lat,
										lng:rec.assetDetail.lng,
										name:rec.contractorInfo.name,
										photos:rec.assetDetail.photos,
										remarks:rec.remarks!=undefined?rec.remarks:[],
										actionRemarks:rec.actionRemarks!=undefined?rec.actionRemarks:{key:"",old:""},
										idate:idate
									});
								}catch(e){
									console.log("exp:assetId:"+assetId );
								}
						}
					}
				}
				
				setFecthOnReq(false);
			});
			setRows(_rows);
			setRowsClone(_rows);
			setTimeout(()=>{
				if(requestDocumentFor!="cross-deadline-project")
					window["initTable"]("w3TxnTable");
			
			},2000);
		}
		
	},[]);
	useEffect(()=>{
		
		
	},[rows])
	const getAssetType=(_catId)=>{
		for(let i=0;i<assetsCategoryList.length;i++){
			if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
		}
		return(_catId);
	}
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const getUserAgencyById=(_id)=>{
		for(let i=0;i<userAgencyList.length;i++){
			if(userAgencyList[i].userAgencyId===_id) return(userAgencyList[i].userAgencyName);
		}
		return(_id);
	}
	const loadAssetCategoryList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_asset_category.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setAssetsCategoryList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadImplAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadFundingAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_funding_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setFundingAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadUserAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_user_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setUserAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	const copyi=(e)=>{
		//window.document.getElementById('audiox').play();
		//console.log(e.target.id);
		window.navigator.clipboard.writeText(e.target.getAttribute("a"));
	}
	const updateByDelayedDays=(e)=>{

		setRows([]);
		setCols([
			
			"Asset.Type",
			"Asset.Name",
			"Implementing.Agency",
			"Funding.Agency",
			"User.Agency",
			"Panchayat",
			"Block",
			"Beneficiary",
			"Agr.Cost",
			"Agr.Date",
			"Est.Cost",
			"EstWorkStartDate",
			"EstWorkCompleteByDays",
			"WorkStartDate",
			"WorkFinishDate",
			"WorkStatus",
			"WorkProgress",
			"Lat",
			"Lng",
			"ContractorName"
			
		]);
		setFecthOnReq(true);
		let _rows=[];
		const delayBy=e.target.value;
		let delayMs=0;
		if(delayBy!=""){
			delayMs=parseInt(delayBy)*1000*60*60*24;
		}
		else {setFecthOnReq(false);setRows(rowsClone);return;};
		
		for(let i=0;rowsClone!=null && i<rowsClone.length;i++){
			try{
				let rec=rowsClone[i];
				let _currentDate=new Date();
				let estWorkStartDate=rec.estWorkStartDate;
				let estWorkCompleteByDays=parseInt(rec.estWorkCompleteByDays);
				let _date=new Date(estWorkStartDate);
				_date.setDate(_date.getDate()+estWorkCompleteByDays);
				let diff=_currentDate.getTime()-_date.getTime();
				if(_currentDate.getTime()>_date.getTime() && diff>=delayMs){
					_rows.push({ 
						slno:rec.slno,
						assetId:rec.assetId,
						assetType:rec.assetType,
						assetName:rec.assetName,
						implementAgency:rec.implementAgency,
						fundingAgency:rec.fundingAgency,
						userAgency:rec.userAgency,
						assetDescription:rec.assetDescription,
						panchayat:rec.panchayat,
						block:rec.block,
						beneficiary:rec.beneficiary,
						agrCost:rec.agrCost,
						agrDate:rec.agrDate,
						estCost:rec.estCost,
						estWorkStartDate:rec.estWorkStartDate,
						estWorkCompleteByDays:rec.estWorkCompleteByDays,
						workStartDate:rec.workStartDate,
						workFinishDate:rec.workFinishDate,
						workStatus:rec.workStatus,	// Ongoing | Completed | Paused
						workProgress:rec.workProgress, // 5 10 15 20.....100
						lat:rec.lat,
						lng:rec.lng,
						name:rec.name,
						photos:rec.photos,
						remraks:rec.remarks!=undefined?rec.remarks:[],
						
					});	
				console.log(_currentDate+"::"+_date.getTime()+"="+diff);
				}
			}catch(e){console.log(e)}
		}
		setFecthOnReq(false);
		setRows(_rows);
		
	}
	return (
        <>
		<GlobalStyles />
		<div className='row'>
		<div className='col-md-10'>	
			<div className='d-flex'>
				<div className="flex-grow-1">
				<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i> Work updated list</h5>
				</div>
				<div className="d-flex gap-1">
						
				<button className="btn btn-primary"
			disabled={disabled}
			onClick={e=>{
				function senetizeCSV(_v){ 

					return((_v+"").replace(new RegExp('[,\r\n\"]', 'ig'), " "));
				}
				function download(data){
					const blob = new Blob([data], { type: 'text/csv' });
  					const url = window.URL.createObjectURL(blob)
					const a = document.createElement('a')
					a.setAttribute('href', url)
					a.setAttribute('download', 'download.csv');
					a.click()
				}
				let objArray=rows;
					var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
					let header=[
						"Slno",
						"id",
						"AssetId",
						"Implementing Agency",
						"Funding Agency",
						"User Agency",

						"Asset Type",
						"Assets Name",
						"Assets Description",

						"Panchayat",
						"Block",
						"Beneficiary",

						"Agreement Cost",
						"Agreement Date",
						"Estimeted Cost",
						"Estimeted work start date",
						"Estimeted working days",
						"Work start date",
						"Work finish date",
						"Work status",
						"WorkProgress",
						"Latitude",
						"Longitude",
						"Contractor Name",
						"Photos"
					];
					setDisabled(true);
					var str = header.join(",")+"\r\n";
					for (var i = 0; i < array.length; i++) {
						var line = '';
						line=line+(array.length-i);
						line=line+","+array[i].slno;
						line=line+","+array[i].assetId;
						line=line+","+getImplAgencyById(senetizeCSV(array[i].implementAgency));
						line=line+","+senetizeCSV(array[i].fundingAgency);
						line=line+","+getUserAgencyById(senetizeCSV(array[i].userAgency));
						line=line+","+getAssetType(senetizeCSV(array[i].assetType));
						line=line+","+senetizeCSV(array[i].assetName);
						line=line+","+senetizeCSV(array[i].assetDescription);

						line=line+","+senetizeCSV(array[i].panchayat);
						line=line+","+senetizeCSV(array[i].block);
						line=line+","+senetizeCSV(array[i].beneficiary);

						line=line+","+senetizeCSV(array[i].agrCost);
						line=line+","+senetizeCSV(array[i].agrDate);
						line=line+","+senetizeCSV(array[i].estCost);
						line=line+","+senetizeCSV(array[i].estWorkStartDate);
						line=line+","+senetizeCSV(array[i].estWorkCompleteByDays);
						line=line+","+senetizeCSV(array[i].workStartDate);
						line=line+","+senetizeCSV(array[i].workFinishDate);
						line=line+","+senetizeCSV(array[i].workStatus);
						line=line+","+senetizeCSV(array[i].workProgress);
						line=line+","+senetizeCSV(array[i].lat);
						line=line+","+senetizeCSV(array[i].lng);
						line=line+","+senetizeCSV(array[i].name);
						line=line+","+senetizeCSV(array[i].photos);
						//line=line+senetizeCSV(array[i].assetType);
						//line=line+senetizeCSV(array[i].assetType);
						//line=line+senetizeCSV(array[i].assetType);
						//line += (array[i][index]+"").replace(new RegExp(',', 'ig'), "\,");
						str += line + '\r\n';
					}
					//console.log(str);
					download(str);
					setDisabled(false);
			}}
			>
				Download.CSV
			</button>
					{ isDelayPage==true?<select className="form-select ms-2" onChange={e=>updateByDelayedDays(e)}>
						<option value="">Select delay</option>
						<option value="10">10 Days</option>
						<option value="20">20 Days</option>
						<option value="30">30 Days</option>
						<option value="45">45 Days</option>
						<option value="60">60 Days</option>
						<option value="90">3 months</option>
						<option value="180">6 months</option>
						<option value="270">9 months</option>
						<option value="365">1 year</option>
					</select>
					:<></>
					}
				</div>
			</div>
		</div>				
		<div className='col-md-10'>
			<div className='card' style={{overflowX:"scroll",width:"99%!important"}}>
			<div className="card-body" >
			{fetchOnReq===true?
				<>
					<img src={Waiter} className='waiter-md'/>
				</>
			:
				<table id="w3TxnTable" className="table table-sm" >
					<thead>
						<tr>
							
							<td>Slno</td>
							<td>View</td>
							<td>Photos</td>
							
							
							{cols && cols.map((item,i)=>{
								return(
									<th key={'tfx423_'+i}><span>{item}</span></th>	
								)
							})
							}
						
						</tr>
					</thead>
					<tbody>
						{rows && rows.map((item,i)=>{
								return(
									<tr key={'t423_'+i}>
										
										<td>{(i+1)}</td>
										<td>
											<div 
												className="cursor-pointer"
												onClick={e=>{
													let ai=item.assetId;
													
													navigate(URLPREFIX+"/view/document-detail?"+ai);
												}}
											>
												Show
											</div>
										</td>
										<td>
										<div className="imgInCol">
											{
											item && item.photos && item.photos.split(",").map((ph,iph)=>{
											 return(iph>0?
													
														<img src={API_CORE_SERVER+"/_apithumbnail/"+ph}
														data={ph}
														className="cursor-pointer"
														onClick={e=>{
															
															setSelectedImages([e.target.getAttribute("data")]);
															setShowImageBox(true);
														}}
														/>
													
													:<></>
												)
											})}</div></td>
										<td>{item.idate}</td>	
										<td>{item.actionRemarks.key}</td>
										<td>{getAssetType(item.assetType)}</td>
										<td>{item.assetName}</td>
										<td>{getImplAgencyById(item.implementAgency)}</td>
										<td>{item.fundingAgency}</td>
										<td>{getUserAgencyById(item.userAgency)}</td>
										<td>{item.panchayat}</td>
										<td>{item.block}</td>
										<td>{item.beneficiary}</td>
										<td>{item.agrCost}</td>
										<td>{item.agrDate}</td>
										<td>{item.estCost}</td>
										<td>{item.estWorkStartDate}</td>
										<td>{item.estWorkCompleteByDays}</td>
										<td>{item.workStartDate}</td>
										<td>{item.workFinishDate}</td>
										<td>{item.workStatus}</td>
										<td>{item.workProgress}</td>
										<td>{item.lat}</td>
										<td>{item.lng}</td>
										<td>{item.name}</td>
										
									</tr>	
								)
					})
					}
					</tbody>
					
				</table>
			}
			</div>	
			</div>
		</div>
		
	</div>	
		{showImageBox===true &&
		<>
		<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4">
				<div className="cursor-pointer text-dark" onClick={()=>{
					setShowImageBox(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row vw-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
					<div className='text-center text-black fs-6'  >
					<img src={API_CORE_SERVER+"/_apistorage/"+selectedImages[0]} style={{maxWidth:'450px',maxHeight:'450px'}}  />
					</div>
					<div className='pt-4 text-end' >
						<button className='btn btn-secondary' onClick={()=>{
						setShowImageBox(false);
						}}>Close</button>
					</div>
				</div>
				</div>
			</div>
		</div>
		</>
		}

		{showQRBox===true &&
		<>
		<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4">
				<div className="cursor-pointer text-dark" onClick={()=>{
					setShowQRBox(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row vw-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
					<div className='text-center text-black fs-6'  >
					<img src={selectedQRImage} style={{maxWidth:'450px',maxHeight:'450px'}}  />
					</div>
					<div className='pt-4 text-end' >
						<button className='btn btn-secondary' onClick={()=>{
						setShowQRBox(false);
						}}>Close</button>
					</div>
				</div>
				</div>
			</div>
		</div>
		</>
		}


        </>
    )
}

export default JComponent;